var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"applications"},[_c('div',{staticClass:"main-window main-window-with-sidebar"},[_c('Navigation'),_c('Sidebar',[_c('iframe',{staticClass:"w-full h-full",attrs:{"src":_vm.getNRUrl}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }